import React from 'react';

import styles from './CustomerShortDetails.module.scss';

const CustomerShortDetails = ({photo, name, phone}) => {
    return (
        <div className={styles.customerShortDetails}>
            <p className={styles.customerShortDetails_title}>Замовник</p>
            <div className={styles.customerShortDetails_bio}>
                <img src={photo} alt="user`s photo"/>
                <div>
                    <p>{name}</p>
                    {phone && <p>{phone}</p>}
                </div>
            </div>
        </div>
    );
};

export default CustomerShortDetails;
